import * as Sentry from "@sentry/react";

export async function apiFetch(url, options = {}) {
  try {
    const response = await fetch(url, options);
    if (!response.ok && response.status >= 500) {
      Sentry.captureMessage(`API ${response.status}: ${url}`, "error");
    }
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
}
